import * as React from 'react';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isRetentionPolicyStateDirty from './selectors/isRetentionPolicyStateDirty';
import saveRetentionPoliciesEdit from './orchestrators/saveRetentionPoliciesEdit';
import RetentionPoliciesFull from './components/RetentionPoliciesFull';
import { resetRetentionPoliciesEdit } from './actions/internalActions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import isUserAtActivePolicies from './selectors/getIsUserAtActivePolicies';

let RetentionPoliciesOption: Option = {
    key: 'retentionPoliciesOption',
    titleStringKey: 'optionTitle_retentionPolicies',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_retentionPolicies',
    fullOptionFormSettings: {
        render: () => <RetentionPoliciesFull />,
        isDirty: () => !isUserAtActivePolicies(), // We need to show discard always on the available policies page since there is no back button yet
        onSave: () => saveRetentionPoliciesEdit(),
        onDiscard: () => resetRetentionPoliciesEdit(),
        disableSave: () => !isRetentionPolicyStateDirty(),
        hideSaveDiscard: () => isUserAtActivePolicies(),
    },
    isHidden: () => {
        return (
            !isFeatureEnabled('tri-retentionPolicies') ||
            isConsumer() ||
            !getUserConfiguration().RetentionPolicyTags
        );
    },
    allowedOptionKeys: ['RetentionPolicies'],
};

export default RetentionPoliciesOption;
